// extracted by mini-css-extract-plugin
export default {"fab":"mapMenu_fab__ZafAw","mapSettings":"mapMenu_mapSettings__x76qh","closeButton":"mapMenu_closeButton__rMUTa"};